import { extractCloudIdFromAri } from '../../../common/utils/sites';

export type JiraIssueHydrationItem = {
	id: string;
	issueKey: string;
};

export const getJiraIssueHydrationInputs = (
	items: readonly JiraIssueHydrationItem[],
): {
	issueKeys: string[];
	issueKeysByCloudId: ReadonlyMap<string, readonly string[]>;
} => {
	const issueKeys = new Set<string>();
	const issueKeysByCloudId = new Map<string, Set<string>>();

	for (const { id, issueKey } of items) {
		issueKeys.add(issueKey);
		const issueCloudId = extractCloudIdFromAri(id);
		if (issueCloudId) {
			const siteIssueKeys = issueKeysByCloudId.get(issueCloudId) ?? new Set<string>();
			siteIssueKeys.add(issueKey);
			issueKeysByCloudId.set(issueCloudId, siteIssueKeys);
		}
	}

	return {
		issueKeys: Array.from(issueKeys),
		issueKeysByCloudId: new Map(
			Array.from(issueKeysByCloudId, ([siteCloudId, siteIssueKeys]) => [
				siteCloudId,
				Array.from(siteIssueKeys),
			]),
		),
	};
};
